/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Action_DraftInputs */

const en_us2_search_action_draft = /** @type {(inputs: Search_Action_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review draft`)
};

const pt_br2_search_action_draft = /** @type {(inputs: Search_Action_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisar rascunho`)
};

const es_419_search_action_draft = /** @type {(inputs: Search_Action_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisar borrador`)
};

const pt_pt2_search_action_draft = /** @type {(inputs: Search_Action_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rever rascunho`)
};

const fr_fr2_search_action_draft = /** @type {(inputs: Search_Action_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir le brouillon`)
};

const de_de2_search_action_draft = /** @type {(inputs: Search_Action_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entwurf prüfen`)
};

const it_it2_search_action_draft = /** @type {(inputs: Search_Action_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rivedi la bozza`)
};

/**
* | output |
* | --- |
* | "Review draft" |
*
* @param {Search_Action_DraftInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_action_draft = /** @type {((inputs?: Search_Action_DraftInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Action_DraftInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_action_draft(inputs)
	if (locale === "es-419") return es_419_search_action_draft(inputs)
	if (locale === "pt-PT") return pt_pt2_search_action_draft(inputs)
	if (locale === "fr-FR") return fr_fr2_search_action_draft(inputs)
	if (locale === "de-DE") return de_de2_search_action_draft(inputs)
	if (locale === "it-IT") return it_it2_search_action_draft(inputs)
	return en_us2_search_action_draft(inputs)
});
export { search_action_draft as "search.action_draft" }